import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from './theme/ThemeProvider';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login from './pages/Login';
import Download from './pages/Download';
import MainLayout from './components/Layout/MainLayout';
import FileUploadArea from './components/FileUpload/FileUploadArea';
import FileList from './components/FileList/FileList';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

const AppRoutes: React.FC = () => {
  const { loading } = useAuth();

  if (loading) return null;

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/download/:fileId/:filename" element={<Download />} />
      <Route path="/download/:fileId" element={<Download />} />

      {/* Upload is public - works with or without login */}
      <Route
        path="/"
        element={
          <MainLayout>
            <FileUploadArea />
          </MainLayout>
        }
      />

      {/* My Files requires login */}
      <Route
        path="/files"
        element={
          <ProtectedRoute>
            <MainLayout>
              <FileList />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={3000}
      >
        <AuthProvider>
          <Router>
            <AppRoutes />
          </Router>
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
